import React, { Component } from 'react';
import { Link } from "react-router-dom";
import API from "../../config/api";
import moment from 'moment';

export class FolderView extends Component {

    constructor(props) {
        super(props)
      
        this.state = {
          page: 1,
          category_id: 1,
          data: [],
          total: 0,
          questions: [],
          quizs: [],
          all_categories: []
          
        }
      }
      UNSAFE_componentWillMount() {
        this.getParam("id");
        this.getOneFolder();
        // this.getAllQuestion();
        this.getAllCategories();
      }

      getParam(name) {
        let id = window.location.search.split(`${name}=`)[1]
        this.state.category_id = id;
        // this.setState({category_id : id})
        this.setState({})
        // return 
      }

      getAllCategories = async () => {
        try {
          let query = `page=${this.state.page}`
          let results = await API.getAllCategory(query);
          let data = results.data;
          
          this.setState({ all_categories : data.category });
    
        } catch (error) {
          console.log(error)
        }
      }
    
      getOneFolder = async () => {
        try {
          let query = `folder_id=${this.state.category_id}`
          let results = await API.getOneFolder(query);
    
          let data = results.data;
          console.log(data.quiz.quiz)
          this.setState({ data : data, quizs: data.quiz.quiz });
    
        } catch (error) {
          console.log(error)
        }
      }

      getAllQuestion = async () => {
        try {
          let query = `page=${this.state.page}`
          let results = await API.getAllQuestions(query);

         console.log(results)
    
          let data = results.data.result;
          
          this.setState({ questions : data.quiz, total: data.total });
    
        } catch (error) {
          console.log(error)
        }
      }

      onChangeFile = async (event) => {
        event.preventDefault();
        let file = event.target.files[0];
        const formData = new FormData();
        formData.append("file", file);
        
        try {
          let results = await API.adminUpload(
            formData,
            this.onUploadProgress
          );
          console.log(results)
          
          if (results){
            this.setState({ thumbnail_url: results.filename })
          }
    
        } catch (error) {
          console.log(error)
        }
      }

      onSearch = async (event) => {
        // cateogory_id=1 , s=code,limit=100
        event.preventDefault();
        let value = event.target.value;
        try {
          let query = `s=${value}`
          let results = await API.getAllQuestions(query);
          
          let data = results.data.result.quiz;
          
          this.setState({ quizs : data });
    
        } catch (error) {
          console.log(error)
        }
      }
    
  render() {
    return (
        <div className="col-12">
            <form className="card">
                <h4 className="card-title"><strong>Folder</strong></h4>

                <div className="card-body row">

                    <div className="col-md-6">
                    <div className="form-group">
                        <label className="require" for="input-required">Name</label>
                        <input type="text" className="form-control" id="input-required" value={this.state.data.name} disabled />
                    </div>
                    {/* <div className="form-group">
                        <label for="inputState" className="col-form-label">Parent</label>
                        <select id="inputState" className="form-control">
                        <option>Short Film</option>
                        <option>Funny</option>
                        <option>Love story</option>
                        <option>Sad story</option>
                        </select>
                    </div> */}
                    
                    </div>


                    <div className="col-md-6">
                    <div className="form-group">
                        <label>Description</label>
                        <input type="text" className="form-control" id="input-required" value={this.state.data.description} disabled />
                    </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Code</label>
                        <input className="form-control" type="text" value={this.state.data.code} name='code' onChange={this.handelInput} disabled />
                      </div>
                    </div>
                    <div className="col-md-6"></div>
                    <div className="col-md-6">
                    {/* <div className="form-group">
                        <label>Thumbnail</label>
                        <img className='h-300px w-fullscreen' src={this.state.categories.thumbnail_url} alt="..." />
                        <br />
                        <input type="file" data-provide="dropify" />
                    </div> */}
                    </div>


                    
                    

                    
                </div>




                <div className="card-body">

            <div className="flexbox mb-20">
                <div className="lookup">
                  <input className="w-200px" type="text" name="s" placeholder="Search" onChange={this.onSearch} />
                </div>

                <div className="btn-toolbar">
                  <div className="btn-group btn-group-sm">
                    {/* <button className="btn" title="Refresh" data-provide="tooltip"><i class="ion-refresh"></i>  </button> */}
                    {/* <button className="btn" title="Add new" data-provide="tooltip"><i class="ion-plus-round"></i></button> */}
                    {/* <Link to="/categorynew" > <button className="btn btn-primary" title="Add new" data-provide="tooltip"> <i className="ion-plus-round"></i></button></Link> */}
                    {/* <Link to="/user/new" > <button className="btn" title="Add new" data-provide="tooltip"><i class="ion-plus-round"></i>New</button></Link> */}
                  </div>

                  {/* <div className="btn-group btn-group-sm ml-2 d-none d-sm-flex">
                    <button className="btn dropdown-toggle" data-toggle="dropdown">Export</button>
                    <div className="dropdown-menu dropdown-menu-right">
                      <a className="dropdown-item" href="/">CSV</a>
                      <a className="dropdown-item" href="/">SQL</a>
                      <a className="dropdown-item" href="/">PDF</a>
                      <a className="dropdown-item" href="/">Text</a>
                    </div>
                  </div> */}
                </div>
              </div>
            <div>
          </div>
          </div>





               

                <h4 className="card-title"><strong>Quiz</strong></h4>
                <table className="table table-hover table-has-action">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Thumbnail</th>
                      <th>Name</th>
                      <th>Question</th>
                      {/* <th>Description Kh</th>
                      <th>Description En</th> */}
                      <th>Code</th>
                      <th>Category</th>
                      <th>Release Date</th>
                      <th className="text-center w-150px">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                  {
                    this.state.quizs && this.state.quizs.map((quiz, index)=> {
                      return <tr>
                        <th scope="row">{( (this.state.page - 1) * 10) + (index+ 1)}</th>
                        {/* <td><img style={{width: 30, height: 30, borderRadius: 30}} src={video.thumbnail_url} alt="video thumbnail" /></td> */}
                        <td>
                          <div class="media">
                            <img class="avatar" src={quiz.full_image_url ? quiz.full_image_url : require('../../assets/assets_theme/img/avatar/1.jpg')} alt="..." />
                            <div class="media-body">
                              {/* <p >{video.title_kh}</p> */}
                            </div>
                          </div>
                        </td>
                        <td>{quiz.name}</td>
                        <td>{quiz.question}</td>
                        {/* <td>{video.description_kh}</td>
                        <td>{video.description_en}</td> */}
                        <td className="w-100px">{quiz.code}</td>
                        <td className="w-100px">{this.state.all_categories.map((category, index) => {
                          if(category.id === quiz.category_id) {
                            return category.name
                          }
                           
                        })}</td>
                        <td>{moment(quiz.created_at).format("DD-MMM-YYYY")}</td>
                        <td className="text-right table-actions">
                          {/* <Link title="View" class="btn btn-square btn-round btn-primary" to={`/userview?id=${user.id}`}><i className="fa fa-eye"></i></Link> */}
                          <Link className="btn btn-square btn-round btn-primary" title="View" to={`/questionedit?id=${quiz.id}`}><i className="fa fa-eye"></i></Link>
                          <span>&nbsp;</span><Link className="btn btn-square btn-round btn-info" title="Edit" to={`/questionedit?id=${quiz.id}`}><i className="ti-pencil"></i></Link>
                        
                          <span>&nbsp;</span><Link title="Delete" onClick={() => this.setState({data: quiz})} className="btn btn-square btn-round btn-danger"><i className='ti-trash' data-toggle="modal" data-target="#modal-center" ></i> </Link>

                          {/* <div className="dropdown table-action">
                            <span className="dropdown-toggle no-caret hover-primary" data-toggle="dropdown" title="More"><i class="ti-more-alt rotate-90"></i></span>
                            <div className="dropdown-menu dropdown-menu-right">
                              <a className="dropdown-item" href="/"><i class="ti-menu-alt"></i> Details</a>
                              <a className="dropdown-item" href="/"><i class="ti-clip"></i> Add file</a>
                              <a className="dropdown-item" href="/"><i class="ti-bar-chart"></i> Performance</a>
                            </div>
                          </div> */}
                        </td>
                      </tr>
                      
                    })
                  }
                  </tbody>
                </table>

                <footer className="card-footer text-right">
                    <Link className="btn btn-secondary" to="/folderindex">Back</Link>
                </footer>
            </form>
        </div>
    )
  }
}

export default FolderView